import {
  FluidPaginationState,
  FluidSortOrder,
  FluidTableHeader,
} from '@lmig/fluid-core';

import { FluidStore } from '../../../utils/store/store.class';
import { TableElementStore } from './table-element.store';

export type RecordOf<T> = { [key: string]: T };

export interface FluidTableSortState {
  header: FluidTableHeader;
  sortDirection: FluidSortOrder;
}

export interface TableState {
  pagination: FluidPaginationState;
  elementStore: TableElementStore;
  sortState?: FluidTableSortState;
}

export class TableStateStore extends FluidStore<TableState> {
  constructor(
    pagination: FluidPaginationState,
    elementStore: TableElementStore,
    sortState?: FluidTableSortState
  ) {
    super({ pagination, elementStore, sortState });
  }

  // ================================================================ //
  // -- Pagination State

  /**
   * Sets the current pagination state of the table
   * @param paginationState
   */
  setPaginationState(paginationState: Partial<FluidPaginationState>) {
    this.setValue('pagination', {
      ...this.getValue('pagination'),
      ...paginationState,
    });
  }

  getPaginationState(): FluidPaginationState {
    return this.getValue('pagination') as FluidPaginationState;
  }

  getPaginator(): HTMLFluidPaginatorElement {
    return (this.getValue('elementStore') as TableElementStore).getPaginator();
  }

  // ================================================================ //
  // -- Sorting State

  setSortState(header: FluidTableHeader, sortDirection: FluidSortOrder) {
    this.setValue('sortState', { header, sortDirection });
  }

  getSortState(): FluidTableSortState {
    return this.getValue('sortState') as FluidTableSortState;
  }

  clearSortState(): void {
    this.setValue('sortState', undefined);
  }
}
